<template>
  <Component v-if="showTitle" :is="value?.style">{{ value?.text }}</Component>
</template>

<script lang="ts" setup>
import type { TitleStyle } from '@core/types/generated'

const props = defineProps<{
  value: { text: string; style: TitleStyle } | null
}>()

const showTitle = computed(() => {
  return (
    props.value?.text &&
    (props.value.style === 'h1' || !hasInvalidPlaceholderValue(props.value.text))
  )
})
</script>
